import userNewbie from "../media/undraw_chill-guy-avatar_tqsm.svg"
import userJourneyman from "../media/undraw_indie-hacker-avatar_b3wy.svg"
import userMaster from "../media/undraw_deep-thinker-avatar_6xg6.svg"
import userPro from "../media/undraw_professor-avatar_y9ai.svg"
import usefbStore from "../store/firebasestore"
import { useEffect, useState } from "react"

function AccountLevel() {
  const [userLevel, setUserLevel] = useState(null)
  const accountPoints = usefbStore((s) => s.accountPoints)

  useEffect(() => {
    function getUserLevel(points) {
      if (points >= 4000) {
        setUserLevel("Pro")
      } else if (points >= 2000) {
        setUserLevel("Master")
      } else if (points >= 1000) {
        setUserLevel("Journeyman")
      } else {
        setUserLevel("Rookie")
      }
    }
    
    if (accountPoints !== undefined && accountPoints !== null) {
      getUserLevel(accountPoints)
    }
  }, [accountPoints])

  return (
    <div className="accountLevelsWrap">
      <div className="accountLevelCont">
        <div className={`alcBox ${userLevel === "Rookie" ? "alcBoxAct" : ""}`}>
          <img src={userNewbie} alt="" />
          <span>Rookie</span>
          <div className="requirementsACL">
            <p>- Points</p>
            <p>- Jobs</p>
          </div>
        </div>
        
        <div className={`alcBox ${userLevel === "Journeyman" ? "alcBoxAct" : ""}`}>
          <img src={userJourneyman} alt="" />
          <span>Journeyman</span>
          <div className="requirementsACL">
            <p>1,000+ Points</p>
            <p>250+ Jobs</p>
          </div>
        </div>
        
        <div className={`alcBox ${userLevel === "Master" ? "alcBoxAct" : ""}`}>
          <img src={userMaster} alt="" />
          <span>Master</span>
          <div className="requirementsACL">
            <p>2,000+ Points</p>
            <p>1,000+ Jobs</p>
          </div>
        </div>
        
        <div className={`alcBox ${userLevel === "Pro" ? "alcBoxAct" : ""}`}>
          <img src={userPro} alt="" />
          <span>Professor</span>
          <div className="requirementsACL">
            <p>4,000+ Points</p>
            <p>2,000+ Jobs</p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AccountLevel